import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** True if the error is a server (5xx) or network/connection error — show maintenance view instead of raw message. */
export function isServerOrNetworkError(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false
  const err = error as { response?: { status?: number }; message?: string; code?: string }
  const status = err.response?.status
  if (status != null && status >= 500 && status < 600) return true
  const msg = (err.message || '').toLowerCase()
  const code = (err.code || '').toLowerCase()
  return (
    msg.includes('network error') ||
    msg.includes('failed to fetch') ||
    msg.includes('status code 500') ||
    msg.includes('status code 502') ||
    msg.includes('status code 503') ||
    code === 'econnrefused' ||
    code === 'enotfound' ||
    code === 'econnreset'
  )
}




